var map = {
	"./about.jpg": "a46c",
	"./account.png": "f02b",
	"./default.jpg": "24b4",
	"./guante-5.jpg": "8ce2",
	"./guante-7.jpg": "5d81",
	"./guante-8.jpg": "330b",
	"./header.jpg": "6b2a",
	"./info": "b092",
	"./info.json": "b092",
	"./languages/english": "6d37",
	"./languages/english.json": "6d37",
	"./languages/spanish": "2135",
	"./languages/spanish.json": "2135",
	"./logo.png": "cf05",
	"./logo.svg": "9b19",
	"./logo_diinf.png": "8a0b",
	"./logo_usach.png": "b1c7",
	"./mission.png": "f6b3",
	"./objective.jpg": "7e3d",
	"./person.jpg": "8d03",
	"./purpose.png": "f4c4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";